module.exports = __webpack_public_path__ + "static/media/1017961.34759d2a.png";